import { render, staticRenderFns } from "./branded-box.vue?vue&type=template&id=1e3c0436&"
import script from "./branded-box.vue?vue&type=script&lang=js&"
export * from "./branded-box.vue?vue&type=script&lang=js&"
import style0 from "./branded-box.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports